module.exports = __webpack_public_path__ + "static/media/mcc_sponsors.af870a55.webp";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/state-of-styling/assets/mcc_sponsors.webp
// module id = 1490
// module chunks = 0